import { type CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireScreenEvent, fireTrackEvent, fireUIEvent } from '@atlassian/teams-common/analytics';

import { AnalyticsAction, AnalyticsActionSubject, AnalyticsSource } from './constants';

export { triggerAnalyticsForLoadedPeople, triggerAnalyticsForLoadedTeam } from './slo-events';

export { AnalyticsActionSubject, AnalyticsAction, AnalyticsSource };

export const triggerAnalyticsForClickCreateNewTeam = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
) => {
	fireUIEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.CREATE_NEW_TEAM_LINK,
		action: AnalyticsAction.CLICKED,
	});
};

export const triggerAnalyticsForMenuLink = (
	additionalLinkId: string,
	action: AnalyticsAction,
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	attributes?: {
		product?: string;
		error?: any;
	},
) => {
	fireUIEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.VIEW_PEOPLE_ADDITIONAL_LINK,
		actionSubjectId: additionalLinkId,
		action,
		attributes: {
			integration: 'peopleMenu',
			...attributes,
		},
	});
};

export const triggerAnalyticsForClickViewDirectory = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	isLeftClick: boolean = false,
) => {
	fireUIEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.VIEW_PEOPLE_DIRECTORY_LINK,
		action: AnalyticsAction.CLICKED,
		attributes: {
			isLeftClick,
		},
	});
};

export const triggerAnalyticsForClickInvitePeople = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	attributes?: {
		product?: string;
	},
) => {
	fireUIEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.NAVIGATION_MENU_ITEM,
		actionSubjectId: 'addPeopleNavigationMenuItem',
		action: AnalyticsAction.CLICKED,
		attributes: {
			integration: 'peopleMenu',
			...attributes,
		},
	});
};

export const triggerAnalyticsForClickOnPeople = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	isLeftClick: boolean = false,
) => {
	fireUIEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.PEOPLE_MENU_LINK,
		action: AnalyticsAction.CLICKED,
		attributes: {
			isLeftClick,
		},
	});
};

export const triggerAnalyticsForClickOnTeam = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	isLeftClick: boolean = false,
) => {
	fireUIEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.TEAM_MENU_LINK,
		action: AnalyticsAction.CLICKED,
		attributes: {
			isLeftClick,
		},
	});
};

export const triggerAnalyticsForViewedPeopleMenu = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	isCacheEmpty = false,
) => {
	fireScreenEvent(createAnalyticsEvent, {
		name: 'peopleMenu',
		attributes: {
			isCacheEmpty,
		},
	});
};

export const triggerAnalyticsForRenderedInvitePeople = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
) => {
	fireUIEvent(createAnalyticsEvent, {
		actionSubject: 'addPeopleNavigationItem',
		action: AnalyticsAction.RENDERED,
	});
};

export const triggerAnalyticsForPreFetchData = (createAnalyticsEvent?: CreateUIAnalyticsEvent) => {
	fireTrackEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.PRE_FETCH_DATA,
		action: AnalyticsAction.TRIGGERED,
	});
};

export const triggerAnalyticsForLoadingIndicator = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	duration = 0,
	startTime = 0,
) => {
	fireUIEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.PEOPLE_MENU,
		actionSubjectId: 'loadingIndicator',
		action: AnalyticsAction.VIEWED,
		attributes: {
			duration,
			startTime,
		},
	});
};

export const triggerAnalyticsForFetchingData = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	duration = 0,
	startTime = 0,
) => {
	fireTrackEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.FETCHING_USERS_TEAMS_DATA,
		action: AnalyticsAction.MEASURED,
		attributes: {
			duration,
			startTime,
		},
	});
};

export const triggerAnalyticsForHoverAndClick = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	duration = 0,
	startTime = 0,
) => {
	fireTrackEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.HOVER_AND_CLICK_PEOPLE_BUTTON,
		action: AnalyticsAction.MEASURED,
		attributes: {
			duration,
			startTime,
		},
	});
};

export const triggerAnalyticsForViewedFullUsersAndTeams = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
	usersCount = 0,
	teamsCount = 0,
	duration = 0,
	startTime = 0,
) => {
	fireTrackEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.PEOPLE_MENU,
		action: AnalyticsAction.SUCCEEDED,
		attributes: {
			usersCount,
			teamsCount,
			duration,
			startTime,
		},
	});
};

export const triggerAnalyticsForNoBrowsePeoplePermission = (
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
) => {
	fireUIEvent(createAnalyticsEvent, {
		actionSubject: AnalyticsActionSubject.PEOPLE_MENU,
		action: AnalyticsAction.VIEWED,
		actionSubjectId: 'noBrowsePermission',
	});
};
